import { acceptHMRUpdate, defineStore } from 'pinia'

export const useBusinessDetails = defineStore('businessDetailsForm', {
	namespaced: true,
	state: () => ({
		details: {
			firstname: '',
			lastname: '',
			email: '',
			phone: '',
			company: '',
			state_dropdown_: '',
			custom: '',
		},

		optional: {
			zip: 0,
		},

		errors: null,
		errorsDetails: null,

		detailsSubmitted: false,
		isSubmitting: false,
		isPromotionalPage: false,

		gtmEvent: 'business_getintouch_form_success',
	}),

	getters: {
		allDetails: (state) => ({
			...state.details,
		}),

		isDetailsSubmitted: (state) => state.detailsSubmitted,

		hasErrors: (state) => state.errors,
		hasErrorsEnquireForm: (state) => state.errorsDetails,
	},

	actions: {
		async submitInterestForm() {
			this.checkUrlAndSetOption()

			await useExecuteRecaptcha('get_in_touch').then(async (token) => {
				const isRecaptchaVerified = await useVerifyRecaptcha(token)

				if (!isRecaptchaVerified?.isVerified) {
					this.errorsDetails = [isRecaptchaVerified?.message]
					return
				}

				try {
					const payload = this.allDetails
					if (this.isPromotionalPage) {
						payload.zip = this.optional.zip
					}

					await useFetchForApi('/get-in-touch', {
						method: 'POST',
						body: payload,
					})
					this.detailsSubmitted = true
					trackGtmEvent({
						event: this.gtmEvent,
					})
					trackLinkedinEvent('GETINTOUCH_FORM')
				} catch (error) {
					this.handleErrorDetails(error)
				}
			})
		},

		checkUrlAndSetOption() {
			const route = useRoute()
			const { path } = route

			const pathCustomKey = {
				'/business': 'Business',
				'/business/novated-lease': 'Novated lease',
				'/business/novated-subscription': 'Novated subscription',
				'/business/novated-ev-subscription': 'Novated EV subscription',
				'/business/fleet-subscription': 'Fleet subscription',
				'/business/fleet-subscription/small-business':
					'Fleet subscription',
				'/business/tools-of-trade/employee-benefits':
					'Tools of trades - Employee benefits',
			}

			if (path in pathCustomKey) {
				this.details.custom = pathCustomKey[path]
			} else if (path === '/promotion/auroraenergy/get-electrified') {
				this.isPromotionalPage = true
				this.details.custom = 'Aurora Energy - Get Electrified'
				this.details.state_dropdown_ = 'TAS'
				this.gtmEvent = 'promotion_auroraenergy_register_form_success'
				return
			} else {
				this.details.custom = 'Business'
			}

			this.gtmEvent = 'business_getintouch_form_success'
		},

		handleErrorDetails(error) {
			const message =
				error.message || 'An error occurred. Please try again.'

			this.errorsDetails = [message]
		},

		clearAllStates() {
			this.$reset()
		},

		clearErrors() {
			this.errors = null
			this.errorsDetails = null
		},
	},
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useBusinessDetails, import.meta.hot))
}
